import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {
  fetchAddLessonAction,
  fetchAddLessonProfileAction,
  fetchDeleteLessonAction, fetchEditLessonAction,
  fetchGetInfoAction, fetchGroupListAction,
  fetchOrderCreate,
  fetchSetSpecialityStatusAction,
  fetchSetStatusAction
} from "../../../store/pages/admission/actions";
import {selectStore} from "../../../store/selector";
import {Button, Col, Row, Steps, Image, Spin, message} from "antd";
import {StyledButton, StyledSettingsContainer} from "../AdmissionWithoutRanking/index.styles";
import {LeftOutlined} from "@ant-design/icons";
import {
  ExecutorStepFive,
  ExecutorStepSix,
  ExecutorStepThree,
  ExecutorStepTwo,
  FifthStep,
  MyBreadcrumb
} from "../../../components";
import {admissionStatuses} from "../../../assets/static/admissionStatuses";

import iconNotUpdate from "../../../assets/icons/page/entrant/admission/icon_notDelete.svg";
import iconUpdate from "../../../assets/icons/page/entrant/admission/icon_update.svg"
import iconDownload from "../../../assets/icons/page/entrant/admission/icon_download.svg"
import {StyledSteps} from "../../../components/pages/Entrant/EntrantApplication/index.styles";
import {decodeBase64} from "../../../utils/decodeBase64";
import {encodeBase64} from "../../../utils/encodeBase64";

const {Step} = Steps

export const AdmissionView = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps'])

  const education_order_id = decodeBase64(searchParams.get("education_order_id"));
  const redirect = searchParams.get("redirect");

  useEffect(() => {
    // user_id
    // @ts-ignore
    dispatch(fetchGetInfoAction({education_order_id}))
  }, [])

  const {
    profile: {userProfile: profileData},
    admission: {getInfo, getMarks, groupList, addToStudentList, getTotalResult, examResult}
  } = useSelector(selectStore)

  const [currentStep, setCurrentStep] = useState(0)

  const [locked, setLocked] = useState(false as any)

  const [addLessonVisible, setAddLessonVisible] = useState(false as any)

  const [checkAuthorType, setCheckAuthorType] = useState(false)

  const [checkMarksValue, setCheckMarksValue] = useState(false)

  const [declineReasonText, setDeclineReasonText] = useState(null as any)

  //if source egov, need to hide all buttons (if rejected||accepted 24.06)
  const [sourceEgov, setSourseEgov] = useState(null as any)

  //step 4 decline reason
  const [declineReason, setDeclineReason] = useState(false)

  //step 2 marks array
  const [arr, setArr] = useState([])

  const [currentCollege, setCurrentCollege] = useState({} as any)

  const [checkDisable, setCheckDisable] = useState(false)

  const [checkCounter, setCheckCounter] = useState(0)

  const currentCollegeApplications = getMarks?.data?.educationOrder?.selectedSpecialities.filter((item: any) => item.college_id === currentCollege.college_id)

  //step2 добавить предмет
  const [addLessonItem, setAddLessonItem] = useState({
    education_order_id,
    rating: null,
    subject_name: null,
    type: "common",
    author_type: 3
  });


  //step2 добавить профильный предмет
  const [addLessonProfileItem, setAddLessonProfileItem] = useState({
    education_order_id,
    rating_id: null,
    rating: null,
    subject_name: null,
    speciality_id: null,
    qualification_id: null,
    type: "profile",
    author_type: 3
  })

  //массив для проверки текущего шага
  const [stepsArr, setStepsArr] = useState([] as any)

  //step6
  const [order, setOrder] = useState({
    user_id: null,
    number: null,
    date: dayjs(),
    basis_ru: null,
    basis_kz: null,
    admin_id: null,
    group_id: null,
    sub_admin_id: null,
  })

  useEffect(() => {
    if (getInfo.data && getInfo.data.educationOrder) {
      if (addToStudentList.data && addToStudentList.data.addToStudentList.split(' ')[0] === "success") {
        console.log("Success")
      } else if (addToStudentList.data && addToStudentList.data.addToStudentList.split(' ')[0] !== "success") {
        message.error('Error')
      }

      if (getInfo.data.educationOrder.source === '1') {
        setSourseEgov(true)
      }
    }
  }, [getInfo.data && getInfo.data.educationOrder.status, addToStudentList.data])

  // useEffect(() => {
    // if (getInfo?.data?.educationOrder?.education_form === '2' || getInfo?.data?.educationOrder?.education_form === '3' || getInfo?.data?.educationOrder?.education_type === '1' || getInfo?.data?.educationOrder?.pay_form === '2') {
    //   setTimeout(() => {
    //     navigate(`/entrant-admission-without-ranking?education_order_id=${encodeBase64(getInfo.data.educationOrder.id)}`, {replace: true})
    //   }, 200)
    // }
  // }, [getInfo.success]);

  useEffect(() => {
    if (currentStep === 4) {
      //@ts-ignore
      dispatch(fetchGroupListAction(currentCollege ? currentCollege.current_college_id : 1))
    }
  }, [currentStep])


  useEffect(() => {
    setOrder((prevState: any) => ({
      ...prevState,
      college_id: currentCollege ? parseInt(currentCollege.id) : 1
    }))
  }, [])


  useEffect(() => {
    if (groupList.data && groupList.data.reception) {
      setOrder((prevState: any) => ({
        ...prevState,
        group: null,
        sub_admin: groupList?.data?.reception?.teachers[0]?.fio,
        sub_admin_id: groupList?.data?.reception?.teachers[0]?.id,
        date: dayjs().format('DD.MM.YYYY'),
        admin_id: groupList?.data?.reception?.director?.id
      }))
    }
  }, [groupList.data])

  useEffect(() => {
    // && educationOrder.educationOrder.user_id
    if (getInfo.data && getInfo.data.educationOrder) {
      setOrder((prevState: any) => ({
        ...prevState,
        user_id: getInfo.data.educationOrder.is_entrant ? getInfo.data.educationOrder.user_id : null
      }))
    }
  }, [getInfo.data])

  useEffect(() => {
    if(checkCounter === currentCollegeApplications?.length){
      currentCollegeApplications.map((itemSpeciality:any) => {
        //@ts-ignore
        dispatch(fetchSetSpecialityStatusAction({
          id: itemSpeciality.id,
          status: 20
        }))
      })
      setCheckCounter(0)
      setCurrentStep(currentStep + 1)
    }
  }, [checkCounter]);


  const setStatus = (value: any, type: any) => {

    let neededIndex = getInfo.data && getInfo.data.educationOrder.selectedSpecialities.findIndex((speciality: any) => {
      return getInfo.data.educationOrder.current_college_id === speciality.college.id
    })

    let findStatus = neededIndex >= 0 ? getInfo.data &&
      admissionStatuses.find((item: any) => item.val === parseInt(getInfo.data.educationOrder.selectedSpecialities[neededIndex].status))
      : getInfo.data && admissionStatuses.find((item: any) => item.val === parseInt(getInfo.data.educationOrder.status))

    if (type === "title") {
      return findStatus && t(`admissionView:statuses.${findStatus.val}`)
    } else if (type === "step") {
      return setCurrentStep(getInfo.data.educationOrder.status != "2" ? 0 : (findStatus ? findStatus.step : 0))
    } else if (type === "lock") {
      return setLocked(!(findStatus && findStatus.step > currentStep))
    }
  }

  useEffect(() => {
    if (getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.status) {
      setStatus(getInfo.data.educationOrder.status, "step")
    }
  }, [getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.status])

  useEffect(() => {
    if (getInfo.data) {
      setStatus(getInfo.data.educationOrder.status, "lock")
      setStepsArr(Array.from(Array(currentStep + 1).keys()));
    }
  }, [currentStep])

  useEffect(() => {
    if ((getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.selectedSpecialities) ||
      (getTotalResult.data && getTotalResult.data.educationOrder && getTotalResult.data.educationOrder.selectedSpecialities) ||
      (examResult.data && examResult.data.educationOrder && examResult.data.educationOrder.selectedSpecialities)) {
      let currentCollege = getInfo.data.educationOrder || getTotalResult.data.educationOrder || examResult.data.educationOrder
      let currentCollegeId = getInfo.data.educationOrder.current_college_id || getTotalResult.data.educationOrder.current_college_id || examResult.data.educationOrder.current_college_id


      setCurrentCollege(currentCollege.selectedSpecialities.find((item: any) => item.college_id === currentCollegeId))
    }
  }, [getInfo.data, getTotalResult.data, examResult.data])


  const prevStepButton = () => {
    //закомментить на локалке, иначе вылезет ошибка
    // if(process.env.REACT_APP_ENV !== 'local'){
    //   window.parent.parentFunc();
    // }

    setCurrentStep(currentStep - 1)

    if (currentStep === 3) {
      setDeclineReason(false)
    }
  }

  // const nextStepButton = (value: any) => {
  //   if (locked) {
  //     // @ts-ignore
  //     dispatch(fetchSetStatusAction({
  //       education_order_id,
  //       status: value
  //     }))
  //
  //
  //     if (value == 24) {
  //       // @ts-ignore
  //       dispatch(fetchAddToStudentList(education_order_id))
  //     }
  //
  //     if (value == 26) {
  //       // @ts-ignore
  //       dispatch(fetchDeclineReason({id: education_order_id, decline_reason: declineReasonText}))
  //       setDeclineReasonText(null)
  //     }
  //   } else {
  //
  //     // setCurrentStep(currentStep + 1)
  //   }
  // }

  const isValid = (filteredStepTwo: any) => {
    if (!filteredStepTwo) return false;

    let { profileMarks, requiredMarksByLang } = filteredStepTwo;

    let allProfileMarksValid = profileMarks.every((mark: any) => mark.rating !== null);

    let requiredMarksValid = requiredMarksByLang.some((mark: any) => {
      if (mark.school_subject_id == 10732 || mark.school_subject_id == 10370) {
        return mark.rating !== null;
      }
      return true;
    });

    return allProfileMarksValid && requiredMarksValid;
  };

  const setSpecialtyStatusButton = (id?: any, value?: any) => {

    //это было здесь до рефактора, на всякий
    // setCurrentStep(currentStep + 1)
    //
    // if (value) {
    //   //@ts-ignore
    //   dispatch(fetchSetSpecialityStatusAction({
    //     id: id,
    //     status: value
    //   }))
    // }


    switch (currentStep){
      case 1:
        let filteredStepTwo = getMarks?.data?.educationOrder?.selectedSpecialities.find((item: any) => item.id === id)

        if (isValid(filteredStepTwo)) {
          console.log("haaa???")


          setCheckCounter(checkCounter + 1)
        } else {
          setCheckCounter(0)
          message.error(t("admissionView:marksError", {priority: filteredStepTwo.priority}))
        }
        break;
      case 2:
        // const filteredStepThree = examResult?.data?.educationOrder?.selectedSpecialities.filter((item: any) => item.id === currentCollege.id)
        //
        // const validateStepThree = filteredStepThree.length > 0 ? filteredStepThree.every((item:any) => item.status == 22) : true

        // if(validateStepThree){
          setCurrentStep(currentStep + 1)
        // } else {
        //   message.error(t("admissionView:examError"))
        // }
        break;
      default:
        setCurrentStep(currentStep + 1)

        if (value) {
          //@ts-ignore
          dispatch(fetchSetSpecialityStatusAction({
            id: id,
            status: value
          }))
        }
    }
  }


  const currentStepHandle = (current: any) => {
    if (current < currentStep) {
      if (stepsArr.indexOf(current) !== -1) {
        setCurrentStep(current)
      }
    }
  }

  const addLessonFooterVisibleHandler = (data: any) => {

    setAddLessonVisible(true)

    let newData = {...addLessonProfileItem}
    newData = {
      ...newData,
      qualification_id: data.qualification_id,
      speciality_id: data.speciality_id,
      type: "profile",
      // @ts-ignore
      profile_id: data.id,
      qualification_name: data.qualification.caption,
      qualification_code: data.qualification.code
    }

    setAddLessonProfileItem(newData)
  }

  //добавить обычнй предмет
  const handleLessonRating = (value: any) => {
    let newData = {...addLessonItem};
    newData = {
      ...newData,
      rating: value,
    }

    setAddLessonItem(newData)
  }

  const handleLessonSubjectName = (value: any) => {
    let newData = {...addLessonItem};
    newData = {
      ...newData,
      subject_name: value,
    }

    setAddLessonItem(newData)
  }

  const addLessonHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonAction(addLessonItem))

    setAddLessonItem((prevState: any) => ({
      ...prevState,
      rating: null,
      subject_name: null,
    }))
  }

  //добавить профильный предмет
  const handleLessonProfileRating = (value: any) => {
    let newData = {...addLessonProfileItem};
    newData = {
      ...newData,
      rating: value,
    }

    setAddLessonProfileItem(newData)
  }

  const handleLessonProfileSubjectName = (value: any) => {
    let newData = {...addLessonProfileItem};
    newData = {
      ...newData,
      subject_name: value,
    }

    setAddLessonProfileItem(newData)
  }

  const addLessonProfileHandler = () => {
    // @ts-ignore
    dispatch(fetchAddLessonProfileAction(addLessonProfileItem))

    setAddLessonProfileItem((prevState: any) => ({
      ...prevState,
      subject_name: null,
      rating: null
    }))

    setAddLessonVisible(false)
  }

  //изменить оценку
  const handleEditRating = (value: any, id: any) => {
    // @ts-ignore
    dispatch(fetchEditLessonAction({
      education_order_id,
      rating_id: id,
      rating: value,
    }))
  }

  //удалить оценку
  const handleDeleteRating = (id: any) => {
    dispatch(fetchDeleteLessonAction(id))
  }

  const goBackToList = () => {
    window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}${redirect ? redirect : "/"}`)
  }

  const returnToReviewedHandler = () => {
    // @ts-ignore
    dispatch(fetchSetStatusAction({
      education_order_id,
      status: 32
    }))

    window.location.reload();

    // navigate(`/entrant-admission-accept-reject/${education_order_id}/`, {replace: true})
  }

  const returnToReviewedSpecialityHandler = (id: any, status: any) => {
    setCurrentStep(0)

    if (status) {
      //@ts-ignore
      dispatch(fetchSetSpecialityStatusAction({
        id: id,
        status: status
      }))
    }

  }

  const revokeHandler = () => {

    switch (currentCollege.status) {
      case 8:
      case 20:
      case 21:
      case 28:
      case 29:
        navigate(`/entrant-admission-accept-reject/${encodeBase64(education_order_id)}/note?type=revoke`, {replace: true})
        break;
      default:
        message.error("На текущем статусе нельзя отозвать заявление")

    }

  }

  const takePdfReceiptHandler = () => {
    window.open(`${process.env.REACT_APP_URL_OLD_REST}${getInfo.data && getInfo.data.educationOrder.receipt_pdf_url}`, "_blank")
  }

  const groupHandler = (value: any, option: any) => {
    setOrder((prevState: any) => ({
      ...prevState,
      group: option.key,
      group_id: parseInt(value),
      group_kk: option.caption_kk
    }))
  }

  const subAdminsHandler = (value: any, option: any) => {
    setOrder((prevState: any) => ({
      ...prevState,
      sub_admin: option.key,
      sub_admin_id: parseInt(value)
    }))
  }

  const dateHandler = (value: any) => {
    setOrder((prevState: any) => ({
      ...prevState,
      date: value
    }))
  }

  const numberHandler = (value: any) => {
    setOrder((prevState: any) => ({
      ...prevState,
      number: value
    }))
  }

  const basisRuHandler = (value: any) => {
    setOrder((prevState: any) => ({
      ...prevState,
      basis_ru: value
    }))
  }


  const basisKzHandler = (value: any) => {
    setOrder((prevState: any) => ({
      ...prevState,
      basis_kz: value
    }))
  }

  const handleCheckSomeStatus = (status:any) => {
    switch(status){
      case 21:
      case 22:
      case 23:
      case 24:
      case 26:
      case 27:
      case 30:
      case 31:
      case "21":
      case "22":
      case "23":
      case "24":
      case "26":
      case "27":
      case "30":
      case "31":
        return true
      default:
        return false
    }
  }

  const createOrderHandler = () => {
    //@ts-ignore
    if (order.group_id && order.date && order.sub_admin_id && order.number && order.basis_ru && order.basis_kz) {
      // @ts-ignore
      // dispatch(fetchSetStatusAction({
      //   education_order_id,
      //   status: 27
      // }))

      let currentAcceptedChild = getTotalResult.data && getTotalResult?.data?.educationOrder?.selectedSpecialities.filter((item: any) => item.college_id === currentCollege.college_id).find((item: any) => item.status === '30' || item.status === '24' || item.status === '27' )

      //@ts-ignore
      // dispatch(fetchSetSpecialityStatusAction({
      //   id: currentAcceptedChild.id,
      //   status: 27
      // }))
      // @ts-ignore
      dispatch(fetchOrderCreate({...order, date: dayjs(order.date).format("YYYY-MM-DD"), selected_speciality_id: currentAcceptedChild.id, currentAcceptedChildId: currentAcceptedChild.id}))
    } else {
      message.error(t("alert.stepSix"));
    }
  }
  const declineReasonTextHandler = (value: any) => {
    setDeclineReasonText(value)
  }

  const handleRenderHeaderButtons = () => {
    let localEducationOrder = getInfo?.data?.educationOrder

    if(!currentCollege || !sourceEgov || localEducationOrder?.status == '2'){
      return (
          localEducationOrder?.selectedSpecialities &&
          Array.isArray(localEducationOrder?.selectedSpecialities) &&
          localEducationOrder?.selectedSpecialities
              .filter((item: any) => item.college_id === localEducationOrder?.current_college_id)
              .some((selectedSpeciality: any) => handleCheckSomeStatus(selectedSpeciality.status))) ? null :
          <>
            <Button
                className="admission__button col-purple br-purple"
                onClick={() => {
                  returnToReviewedHandler()
                  localEducationOrder.selectedSpecialities
                      .filter((item: any) => item.college_id === localEducationOrder.current_college_id)
                      .map((item: any) => returnToReviewedSpecialityHandler(item.id, 32))
                }}
            >
              {t('admissionView:stepsButton.backToNew')}
              <Image
                  src={iconUpdate}
                  preview={false}
              />
            </Button>
            {localEducationOrder.selectedSpecialities[0].college_id === localEducationOrder.current_college_id && localEducationOrder.selectedSpecialities.some((selectedSpecialities:any) => selectedSpecialities?.raging?.status != null || selectedSpecialities?.raging?.status != 2) ? (
                <Button
                    className="admission__button col-orange br-orange"
                    onClick={() => revokeHandler()}
                >
                  {t('admissionView:stepsButton.revoke')}
                  <Image
                      src={iconNotUpdate}
                      preview={false}
                  />
                </Button>

            ) : null}
          </>
    }

  }

  const steps = [
    {
      title: `${t('admissionView:stepsCaptions.stepOne')}`,
      content:
        <FifthStep
          educationOrder={getInfo.data}
        />
    },
    {
      title: `${t('admissionView:stepsCaptions.stepTwo')}`,
      content:
        <ExecutorStepTwo
          addLessonFooterVisibleHandler={addLessonFooterVisibleHandler}
          addLessonVisible={addLessonVisible}

          addLessonItem={addLessonItem}
          addLessonProfileItem={addLessonProfileItem}

          handleLessonRating={handleLessonRating}
          handleLessonSubjectName={handleLessonSubjectName}

          handleLessonProfileRating={handleLessonProfileRating}
          handleLessonProfileSubjectName={handleLessonProfileSubjectName}

          handleEditRating={handleEditRating}
          handleDeleteRating={handleDeleteRating}

          addLessonHandler={addLessonHandler}

          addLessonProfileHandler={addLessonProfileHandler}

          locked={locked}
          setLocked={setLocked}
          setCheckAuthorType={setCheckAuthorType}

          arr={arr}
          setArr={setArr}
          setCheckMarksValue={setCheckMarksValue}

          currentCollege={currentCollege}
        />
    },
    {
      title: `${t('admissionView:stepsCaptions.stepThree')}`,
      content:
        <ExecutorStepThree
          setCheckDisable={setCheckDisable}
          locked={locked}
        />
    },
    {
      title: `${t('admissionView:stepsCaptions.stepFour')}`,
      content:
        <ExecutorStepFive
          declineReason={declineReason}
          declineReasonTextHandler={declineReasonTextHandler}
          currentCollege={currentCollege}
        />
    },
    {
      title: `${t('admissionView:stepsCaptions.stepFive')}`,
      content:
        <ExecutorStepSix
          title={t('admissionView:stepsTitle.stepSix.title.enroll')}
          type='admission'
          fio_entrant={getInfo.data && `${getInfo.data.educationOrder.surname_entrant} ${getInfo.data.educationOrder.name_entrant} ${getInfo.data.educationOrder.patronymic_entrant}`}

          order={order}
          groupList={groupList.data}

          subAdminsHandler={subAdminsHandler}
          dateHandler={dateHandler}
          numberHandler={numberHandler}
          groupHandler={groupHandler}
          basisRuHandler={basisRuHandler}
          basisKzHandler={basisKzHandler}
        />
    }
  ];

  const footerNewButtons = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={() => goBackToList()}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.backToList')}
            </StyledButton>

            {
              !currentCollege || (getInfo.data && getInfo.data.educationOrder && (getInfo.data.educationOrder.status === "26" || getInfo.data.educationOrder.status === "3" || getInfo.data.educationOrder.status === "5" || getInfo.data.educationOrder.status === "6"))
                ? null :
                (getInfo.data.educationOrder.selectedSpecialities.every((selectedSpecialty: any) => selectedSpecialty.qualification && (selectedSpecialty.status != "27")) ?
                  <StyledButton
                    type="primary"
                    onClick={() => {
                      //@ts-ignore
                      // getMarks.data && getMarks.data.educationOrder && getMarks.data.educationOrder.selectedSpecialities.filter((item: any) => item.college_id === getMarks.data.educationOrder.current_college_id).map((item: any) => dispatch(fetchSetSpecialityStatusAction({
                      //   id: item.id,
                      //   status: 32
                      // })))
                      setSpecialtyStatusButton()
                    }}
                    className="admission__button admission__button--item"
                  >
                    {t('admissionView:stepsButton.continue')}
                  </StyledButton>
                  : null)
            }


          </>
        )

      case 1:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={prevStepButton}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.back')}
            </StyledButton>

            {
              currentCollege.status === '32' ?
                <StyledButton
                  type="primary"
                  onClick={() => getMarks.data && getMarks.data.educationOrder && getMarks.data.educationOrder.selectedSpecialities.filter((item: any) => item.college_id === getMarks.data.educationOrder.current_college_id).map((item: any) => {
                    setSpecialtyStatusButton(item.id, 20)
                  })}
                  className="admission__button admission__button--item"
                  // disabled={!checkMarksValue}
                >
                  {t('admissionView:stepsButton.confirm')}
                </StyledButton>
                :
                <StyledButton
                  type="primary"
                  onClick={() => setCurrentStep(currentStep + 1)}
                  className="admission__button admission__button--item"
                >
                  {t('admissionView:stepsButton.continue')}
                </StyledButton>
            }

          </>
        )

      case 2:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={prevStepButton}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.back')}
            </StyledButton>

            <StyledButton
              className="admission__button admission__button--item"
              onClick={() => goBackToList()}
            >
              {t('admissionView:stepsButton.backToList')}
            </StyledButton>


            {/*todo: Если есть какие-либо экзамены, то не пропускать на следующий шаг*/}
            {
              currentCollege.status === '20' || currentCollege.status === '29' ?
                <StyledButton
                  type="primary"
                  onClick={() => examResult.data && examResult.data.educationOrder && examResult.data.educationOrder.selectedSpecialities.filter((item: any) => item.college_id === examResult.data.educationOrder.current_college_id).map((item: any) => setSpecialtyStatusButton(item.id, 22))}
                  className="admission__button admission__button--item"
                  disabled={checkDisable}
                >
                  {t('admissionView:stepsButton.continue')}
                </StyledButton>
                :
                <StyledButton
                  type="primary"
                  onClick={() => setCurrentStep(currentStep + 1)}
                  className="admission__button admission__button--item"
                >
                  {t('admissionView:stepsButton.continue')}
                </StyledButton>
            }

          </>
        )
      case 3:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={prevStepButton}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.back')}
            </StyledButton>

            <StyledButton
              className="admission__button admission__button--item"
              onClick={() => goBackToList()}
            >
              {t('admissionView:stepsButton.backToList')}
            </StyledButton>

            {/*todo локальный стейт для отказался поступать. Проставить условие с бэка для "отказался поступать" и "зачислить"*/}
            {/*todo дождаться апи для отправки коммента "причина отказа"*/}

            {
              <>
                {
                  getTotalResult.data && getTotalResult.data.educationOrder.selectedSpecialities.filter((item: any) => item.college_id === currentCollege.college_id).some((item: any) => item.status == '30' || item.status == '24') &&
                    <StyledButton size='large'
                      // onClick={() => getMarks.data && getMarks.data.educationOrder && getMarks.data.educationOrder.selectedSpecialities.filter(item => item.college_id === getMarks.data.educationOrder.current_college_id).map(item => setSpecialtyStatusButton(item.id,30))}
                                  onClick={() => {
                                    let currentAcceptedChild = getTotalResult.data && getTotalResult.data.educationOrder.selectedSpecialities.filter((item: any) => item.college_id === currentCollege.college_id).find((item: any) => item.status === '30' || item.status === '24' || item.status === '27')

                                    //@ts-ignore
                                    dispatch(fetchSetSpecialityStatusAction({
                                      id: currentAcceptedChild.id,
                                      status: 24
                                    }))

                                    setCurrentStep(currentStep + 1)
                                  }}
                                  style={{marginLeft: 10}}>
                      {t('admissionView:stepsButton.enroll')}
                    </StyledButton>
                }

              </>
            }

            {declineReason &&
                <StyledButton size='large'
                              onClick={() => setSpecialtyStatusButton()}
                              style={{marginLeft: 10}}
                              disabled={!declineReasonText}>

                  {t('admissionView:stepsButton.save')}
                </StyledButton>
            }

          </>
        )

      case 4:
        return (
          <>
            <StyledButton
              className="admission__button admission__button--item"
              onClick={prevStepButton}
            >
              <LeftOutlined/>
              {t('admissionView:stepsButton.back')}
            </StyledButton>

            <StyledButton
              className="admission__button admission__button--item"
              onClick={() => goBackToList()}
            >
              {t('admissionView:stepsButton.backToList')}
            </StyledButton>

            <StyledButton
              type="primary"
              onClick={() => createOrderHandler()}
              className="admission__button admission__button--item"
            >
              {t('admissionView:stepsButton.save')}
            </StyledButton>
          </>
        )
    }
  }

  return (
    <>
      <MyBreadcrumb title={t("admissionView:breadcrumbTitle")} isFullStack isBack link={`${process.env.REACT_APP_FULLSTACK_URL}${redirect ? redirect : "/"}`}/>
      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24} style={{paddingTop: 32, paddingBottom: 32}}>
              <Spin spinning={getInfo.loading || profileData.loading}>
                {getInfo.data && getInfo.data.educationOrder === null
                  ?
                  <h1>{t('admissionView:stepsCaptions.empty')}</h1>
                  :
                  getInfo.loading || addToStudentList.loading ?
                    <Spin style={{
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%"
                    }}/>
                    :
                    getInfo.data && getInfo.data.educationOrder && getInfo.data.educationOrder.iin_entrant !== null ?
                      <StyledSettingsContainer>
                        <div className="card">
                          <div className="admission">
                            <Row justify="space-between">
                              <Col>
                                <h3
                                  className="admission__title">{t('admissionView:stepsCaptions.application')} №{education_order_id}</h3>
                              </Col>

                              <Col className="admission__button-content">
                                {currentStep === 0 && getInfo.data.educationOrder.receipt_pdf_url ? (
                                  <Button
                                    className="admission__button col-blue br-blue"
                                    onClick={() => takePdfReceiptHandler()}
                                  >
                                    {t('admissionView:stepsButton.downloadRaspiska')}
                                    <Image
                                      src={iconDownload}
                                      preview={false}
                                    />
                                  </Button>
                                ) : null}
                                {handleRenderHeaderButtons()}
                              </Col>

                            </Row>
                          </div>

                          <div className="admission">
                            {getInfo.data && getInfo.data.educationOrder && (getInfo.data.educationOrder.status === "26" || getInfo.data.educationOrder.status === "3" || getInfo.data.educationOrder.status === "5" || getInfo.data.educationOrder.status === "6") ?
                              null
                              // <StyledAlertDecline
                              //   message={getInfo.data && getInfo.data.educationOrder.decline_reason !== null ? (getInfo.data.educationOrder.status === "5" ? "Причина отзыва" : t('admissionView:stepsTitle.stepFive.caption.reason')) : "Смотреть расписку"}
                              //   description={getInfo.data && getInfo.data.educationOrder.decline_reason}
                              //   type="error"
                              //   showIcon
                              //   icon={<WarningOutlined/>}
                              // />
                              :
                              <StyledSteps>
                                <Steps
                                  current={currentStep}
                                  labelPlacement="vertical"
                                  onChange={(current) => currentStepHandle(current)}
                                >
                                  {steps.map(item => (
                                    <Step key={item.title} title={item.title}/>
                                  ))}
                                </Steps>
                              </StyledSteps>
                            }

                          </div>

                          <div className="admission">

                            {steps[currentStep].content}

                          </div>

                          <Row style={{background: "#fff", paddingTop: 24, marginBottom: 4}} justify="space-around"
                               className="admission__footer">
                            <Col className="admission__button-content">

                              {footerNewButtons()}

                            </Col>
                          </Row>

                        </div>

                      </StyledSettingsContainer>
                      :
                      <h1>{t('admissionView:stepsCaptions.empty')}</h1>}
              </Spin>
            </Col>
          </Row>
        </Col>
      </Row>
    </>

  )
}